<div class="right-panel-view" *ngIf="profileView">
    <div class="d-flex justify-content-between">
        <h3 class="semi-bold">{{translate.instant('MyProfile')}}</h3>
        <img class="profile-emailimg cursor mr-5 mt-2" id="profile_my_profile"  (click)="redirectToProfile(0)" src="assets/img/profile/expand.svg" />
    </div>
    <div class="profile-container">
        <div class="d-flex justify-content-center mt-4">
            <div class="text-profile d-flex justify-content-center">
                <p class="d-flex align-items-center">
                    {{userDetails?.firstName?.charAt(0)}}{{userDetails?.lastName?.charAt(0)}}</p>
            </div>
        </div>
        <div class="profile-info mt-3 mb-4">
            <h2 class="mb-0 text-center font-weight-bold mb-2">{{userDetails.firstName}} {{userDetails.lastName}}</h2>
            <div class="d-flex justify-content-center mt-3 mb-2">
                <span class="mt-2 mr-3 text-center newcls cursor newactive active-color-ins" id="profile_facility"  (click)="redirectFacility(institutionNameShow)">
                    {{institutionNameShow}}
                </span>
                <span class="border-box" *ngIf='institutionList?.length > 1' id="profile_site_switcher"  (click)="redirectToSwitcher()">
                    <img src="assets/img/profile/group.svg" class="groupFacility" />
                </span>
            </div>
            <div class="d-flex justify-content-center">
                <p class="mb-1 m-0 ml-2 text-center" *ngIf='!isPlatform'>{{roleValue}}</p>

                <p class="mb-1 m-0 ml-2  text-center" *ngIf='isPlatform'>{{userDetails.healthPlusRoleName}}</p>
            </div>
            <div class="mb-2 text-center active-color-ins" *ngIf='isPlatform'>
                {{(userDetails.customerName && userDetails.customerName != "")?userDetails.customerName:institutionname}}
            </div>
            <div class="mb-2 text-center active-color-ins">
                {{userDetails?.applicationName}}
            </div>
            <div *ngIf="userCountries" class="row mb-2 text-center active-color-ins" style="justify-content: center">
                <div *ngFor="let index; let item of userCountries">
                    <mat-icon *ngIf="item" class="mat-icon notranslate mat-icon-no-color mr-2" role="img" aria-hidden="true" ng-reflect-svg-icon="No-incontinence">
                        <div matTooltipClass="tooltip-no-ellipsis"  matTooltip="{{getCountryName(item)}}" [ngStyle]="{'background': 'url(https://storagedhhpsit.blob.core.windows.net/platformassets/countryflags/' + item.toLowerCase() +'.svg)', 'background-size': 'cover', 'background-position': 'center', 'background-repeat': 'no-repeat'}"
                            style="background-size: cover; height: 20px; width:20px; border-radius: 50%;"></div>
                    </mat-icon>
                </div>
            </div>
            <div class="w-100 text-center height-30">
                <img class="" [src]="imm" *ngIf="!isNotHartmannUser" />
            </div>
        </div>
        <div class="mt-4" *ngIf="profileUrl">
            <p class="mb-2 mt-2 text-left active-color cursor" id="profile_details" (click)="redirectToProfile(0)">{{translate.instant('Profile Details')}}</p>
            <mat-divider></mat-divider>
            <p class="mb-2 mt-2  text-left active-color cursor" id="profile_settings"  (click)="redirectToProfile(1)" *ngIf="!isDisableSetting">{{translate.instant('My Settings')}}</p>
            <mat-divider></mat-divider>
            <p class="mb-2 mt-2  text-left active-color cursor" id="profile_services" (click)="redirectToProfile(2)" *ngIf="!isDisableSetting">{{translate.instant('Services')}}</p>
            <mat-divider></mat-divider>
            <p class="mb-2 mt-2 text-left active-color cursor" id="profile_privacy_notice"  (click)="redirectToProfile(3)" *ngIf="!isDisableSetting">
                {{translate.instant('privacyNotice')}}</p>
            <mat-divider *ngIf="isNotHartmannUser"></mat-divider>
            <!-- <p class="mb-2 mt-2 text-left active-color cursor" (click)="redirectToProfile(3)" *ngIf="!isDisableSetting">Preferences</p>
            <mat-divider></mat-divider> -->
            <p class="mb-2 mt-2 text-left active-color cursor" id="profile_change_password"  (click)="redirectToProfile(4)" *ngIf="isNotHartmannUser">
                {{translate.instant('Changepassword')}}</p>
            <mat-divider></mat-divider>
            <!-- <p class="mb-2 mt-2  text-left active-color cursor" [ngClass]="{'disable-hartlink': !isNotHartmannUser}" (click)="redirectToProfile(5)" *ngIf="!isDisableSetting">{{'DeleteAccount'|translate}}
                <mat-icon class="info ml-auto hartIcon" [outsideClick]="true" [popover]="popTemplatehartmann" placement="top" *ngIf="!isNotHartmannUser">info</mat-icon>
            </p> -->
            <p class="mb-2 mt-2  text-left active-color cursor" id="profile_delete_account" (click)="redirectToProfile(5)" *ngIf="!isDisableSetting">{{translate.instant('DeleteAccount')}}

            </p>
            <ng-template #popTemplatehartmann>
                <div>
                    <div class="col">
                        <div class="p-2 h-200">{{'ProfileInfo' | translate}}
                        </div>
                    </div>
                </div>
            </ng-template>
            <mat-divider></mat-divider>
        </div>
        <div class="container mt-2">
            <div class="row col-12 p-0 text-center">
                <div class="col-12 mt-4" *ngIf="logOutUrl">
                    <button mat-raised-button id="profile_logout" (click)="logout()" class="card-header-action mat-primary">
                        {{translate.instant('Logout')}}</button>
                </div>
            </div>
        </div>
    </div>
</div>